var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33325 8.16675L11.859 14.8348C12.6304 15.3747 13.016 15.6447 13.4356 15.7493C13.8061 15.8416 14.1937 15.8416 14.5643 15.7493C14.9838 15.6447 15.3695 15.3747 16.1408 14.8348L25.6666 8.16675M7.93325 23.3334H20.0666C22.0268 23.3334 23.0069 23.3334 23.7556 22.9519C24.4141 22.6164 24.9496 22.081 25.2851 21.4224C25.6666 20.6737 25.6666 19.6936 25.6666 17.7334V10.2667C25.6666 8.30656 25.6666 7.32647 25.2851 6.57778C24.9496 5.91921 24.4141 5.38378 23.7556 5.04823C23.0069 4.66675 22.0268 4.66675 20.0666 4.66675H7.93325C5.97307 4.66675 4.99298 4.66675 4.24429 5.04823C3.58572 5.38378 3.05029 5.91921 2.71473 6.57778C2.33325 7.32647 2.33325 8.30656 2.33325 10.2667V17.7334C2.33325 19.6936 2.33325 20.6737 2.71473 21.4224C3.05029 22.081 3.58572 22.6164 4.24429 22.9519C4.99298 23.3334 5.97307 23.3334 7.93325 23.3334Z",
    stroke: "#414651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.9a0f728e0a216a5eb936f86d75302e3e.svg";
export { ForwardRef as ReactComponent };